import { Button } from '@mui/material';
import withDefaultProps from '../../utils/withDefaultProps';
var BaseButton = withDefaultProps(Button, {
    color: 'primary',
    variant: 'contained',
});
BaseButton.displayName = 'BaseButton';
export default BaseButton;
